"use client";

import { useRouter } from "next/navigation";

export default function PracticeLimitModal() {
  const router = useRouter();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="bg-white rounded-2xl max-w-md w-full p-8 text-center shadow-xl">
        <div className="text-4xl mb-4">🎉</div>
        <h2 className="text-lg font-bold text-on-surface mb-2">
          3回の練習、お疲れさまでした！
        </h2>
        <p className="text-sm text-outline mb-6 leading-relaxed">
          無料アカウントを作れば、
          <br />
          回数無制限でずっと練習できます。
        </p>

        <ul className="text-left text-sm text-on-surface space-y-2 mb-6">
          <li className="flex items-center gap-2">
            <span className="text-[#16A34A]">✓</span>
            練習回数が無制限になる
          </li>
          <li className="flex items-center gap-2">
            <span className="text-[#16A34A]">✓</span>
            練習履歴が保存される
          </li>
          <li className="flex items-center gap-2">
            <span className="text-[#16A34A]">✓</span>
            詳細なフィードバックが受けられる
          </li>
        </ul>

        <div className="flex flex-col gap-3">
          <button
            onClick={() => router.push("/signup?redirect=/practice/select")}
            className="w-full bg-primary hover:bg-primary-hover text-white font-semibold py-3 rounded-lg transition-colors"
          >
            無料で登録する
          </button>
          <button
            onClick={() => router.push("/login?redirect=/practice/select")}
            className="w-full bg-surface border border-outline-variant text-on-surface font-semibold py-3 rounded-lg transition-colors hover:bg-surface-container-low"
          >
            ログイン
          </button>
        </div>
      </div>
    </div>
  );
}
